function setCookie( name, value, days ) {
	let expires = '';
	if ( days ) {
		let date = new Date();
		date.setTime( date.getTime() + ( days * 24 * 60 * 60 * 1000 ) );
		expires = '; expires=' + date.toUTCString();
	}

	document.cookie = name + "=" + ( value || '' )  + expires + '; path=/';
}

function getCookie( name ) {
	const cookie = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
	if(  cookie ) {
		return cookie[2];
	}

	return false;
}

function deleteCookie( name ) {
	setCookie( name, '' );
}


export { setCookie, getCookie, deleteCookie };
